import { Controller } from "stimulus"

// Broker SLA drill-down modal (admin dashboard). Clicking a count link fetches that broker's
// referral list into the modal body; Pagy links inside the response carry data-action
// "sla-drill#page", so paging re-fetches into the same modal instead of navigating the page.
export default class extends Controller {
  static targets = ["modal", "body", "title"]

  open(e) {
    e.preventDefault()
    const link = e.currentTarget
    if (link.dataset.title) this.titleTarget.textContent = link.dataset.title
    this.reveal()
    this.load(link.href)
  }

  // Delegated click on the modal body: a Pagy nav link re-fetches into the modal (keeps paging
  // inside it); any other link (e.g. a referral case-ref) is left to navigate normally.
  bodyClick(e) {
    const pagyLink = e.target.closest("nav.pagy a[href]")
    if (!pagyLink) return
    e.preventDefault()
    this.load(pagyLink.href)
  }

  async load(url) {
    this.bodyTarget.innerHTML = '<p class="px-6 py-10 text-center text-gray-400 text-sm">Loading…</p>'
    try {
      const resp = await fetch(url, { headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" } })
      if (!resp.ok) throw new Error(resp.status)
      this.bodyTarget.innerHTML = await resp.text()
    } catch (_) {
      this.bodyTarget.innerHTML = '<p class="px-6 py-10 text-center text-red-500 text-sm">Could not load referrals.</p>'
    }
  }

  reveal() {
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(e) {
    if (e) e.preventDefault()
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeBackdrop(e) {
    if (e.target === this.modalTarget) this.close(e)
  }
}
